import { Box, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const RegistrationGrid = styled(Grid)({
  minHeight: "60vh",
});

export const RegistrationBox = styled(Box)(({ theme }) => ({
  width: "60%",
  [theme.breakpoints.up("md")]: {
    width: "20%",
  },
}));
